import React, { Component } from "react";
import { connect } from "react-redux";

import {
  HOME,
  PROJECT_LOGIN,
  LOGIN,
  PROJECT_LOGIN_HOME,
  LOGIN_HOME
} from "App/Routes";
import ProjectPage from "./ProjectPage";
import Loading from "components/shared/Loading";
import GenericErrorPage from "components/ErrorPages/GenericError/GenericErrorPage";

import { LOAD_MORE_COUNT, ENABLE_LOGIN_HOME, SINGLE_PROJECT_APP } from "config";
import {
  setProject,
  setButtons,
  setTopicCategory,
  showAlertWithTimeout
} from "actions";
import getApiGenerator from "services/getApiGenerator";
import { GET_TOPICS, GET_PROJECT_POPUP } from "services/api";
import localize from "lang/localize";

import sessionStorageService from "services/sessionStorageService";
import popupStorage from "services/popupStorage";

export const mapStateToProps = (state, ownProps) => {
  return {
    sessionKey: state.sessionKey,
    buttons: state.floatingButtons
      ? state.floatingButtons.buttons || null
      : null,
    projectId: state.projectId,
    user: state.user,
    team: state.team,
    /* Rendering notifications */
    notifications: state.profileDrawer.notifications,
    /* Rendering inbox unread */
    inboxUnread: state.profileDrawer.inboxUnread,
    language: state.language
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setProject: project => {
      dispatch(setProject(project));
    },
    setButtons: buttons => {
      dispatch(setButtons(buttons));
    },
    setTopicCategory: topicCategory => {
      dispatch(setTopicCategory(topicCategory));
    },
    showAlertWithTimeout: alert => {
      dispatch(showAlertWithTimeout(alert));
    }
  };
};

/*
  In Project Container, this.props.id refers to category ID
  while this.props.projectId refers to projectId.
*/
export class ProjectContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topics: null,
      categories: null,
      categoriesData: [],
      more: false,
      page: 1,
      showcaseProject: null,
      code: null,
      error: null,
      popup: null,
      showPopup: false,
      showShareGameDialog: false,
      showTopicsListDialog: false
    };

    this.handleClosePopupAlertDialog = this.handleClosePopupAlertDialog.bind(
      this
    );
    this.handleOpenShareGameDialog = this.handleOpenShareGameDialog.bind(this);
    this.handleCloseShareGameDialog = this.handleCloseShareGameDialog.bind(
      this
    );

    this.handleOpenTopicsListDialog = this.handleOpenTopicsListDialog.bind(
      this
    );
    this.handleCloseTopicsListDialog = this.handleCloseTopicsListDialog.bind(
      this
    );
  }

  getProjectPopup() {
    getApiGenerator(GET_PROJECT_POPUP.format(this.props.projectId), {
      session_key: this.props.sessionKey
    }).end((err, res) => {
      if (err || res.body.code !== 200) {
      } else {
        this.setState({ popup: res.body }, () => {
          this.setState({
            showPopup:
              this.state.popup &&
              !popupStorage.checkPopupShown(this.props.projectId)
          });
        });
      }
    });
  }

  getTopics(page, category_id = this.props.id || "", limit = LOAD_MORE_COUNT) {
    getApiGenerator(
      GET_TOPICS.format(this.props.projectId),
      {
        page: page,
        category_id: category_id,
        limit: limit
      },
      this.props.sessionKey
    ).end((err, res) => {
      if (err || res.body.code !== 200) {
        if (res.body.code === 500) {
          this.setState({
            topics: [],
            code: 500,
            error: res.body.error
          });
        }
      } else {
        const categories = res.body.categories
          ? res.body.categories.map(category => ({
              id: category.id,
              title: category.name,
              selected: category.selected,
              description: category.description,
              image: category.image
            }))
          : null;

        const BUTTONS =
          res.body.buttons && res.body.buttons.length > 0
            ? res.body.buttons
            : null;

        let compiledProject = categories
          ? Object.assign({}, res.body.game, { categories: categories })
          : res.body.game;

        this.setState({
          categories: categories,
          project: res.body.game,
          topics:
            this.state.topics && page !== 1
              ? this.state.topics.slice().concat(res.body.data)
              : res.body.data,
          more: res.body.more,
          page: page + 1,
          showcaseProject: !!res.body.showcaseProjects
            ? res.body.showcaseProjects[0]
            : null,
          code: res.body.code,
          error: ""
        });
        this.props.setProject(compiledProject);
        this.props.setButtons(BUTTONS);

        if (categories) {
          this.props.setTopicCategory(
            categories.filter(category => category.selected === true)[0]
          );
        }
        this.getProjectPopup();
      }
    });
  }

  componentDidMount() {
    this.initializeProject();

    /* Use hashing to show success alert for reset activity */
    if (window.location.hash.slice(0, 14) === "#resettedtopic") {
      this.props.showAlertWithTimeout({
        text: localize("alert_reset_activity_success", this.props.language),
        type: "success"
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // mitigating race conditions in joining user into game
    // checks: (1) if this.state.error and prevState.error are different,
    //         (2) error message check (search for 'join' keyword),
    //         (3) prevState.error is not string (null check)
    // then: call api to get topics again
    // won't go into loop because this.state.error will only be null (otherwise it is a string) before api is called
    if (
      this.state.error !== prevState.error &&
      this.state.error &&
      this.state.error.indexOf("join") !== -1 &&
      typeof prevState.error !== "string"
    ) {
      if (this.props.id) {
        this.getTopics(1, this.props.id);
      } else {
        this.getTopics(this.state.page);
      }
    }

    /* when switching projects */
    if (
      this.props.projectId !== prevProps.projectId &&
      typeof this.props.projectId === "number" &&
      typeof prevProps.projectId === "number"
    ) {
      /* reset states */
      this.setState(
        {
          topics: null,
          categories: null,
          categoriesData: [],
          more: false,
          page: 1,
          showcaseProject: null,
          code: null,
          error: null,
          popup: null,
          showPopup: false
        },
        () => {
          /* reinitialize project */
          this.initializeProject();
        }
      );
    }
  }

  initializeProject() {
    /* popupStates do not exist in sessionStorage */
    if (!sessionStorageService.getItem("popupStates")) {
      popupStorage.initialize(this.props.projectId);
    } else {
      /* popupStates exist in sessionStorage */
      /* popupState for this projectId does not exist */
      if (!popupStorage.checkIdExist(this.props.projectId)) {
        /* add popup state */
        popupStorage.addId(this.props.projectId);
      }
    }

    if (this.props.id) {
      this.getTopics(1, this.props.id);
    } else {
      this.getTopics(this.state.page);
    }
  }

  getLoginRoute() {
    if (this.props.projectId && ENABLE_LOGIN_HOME) {
      return PROJECT_LOGIN_HOME.format(this.props.projectId);
    } else if (this.props.projectId) {
      return PROJECT_LOGIN.format(this.props.projectId);
    } else if (ENABLE_LOGIN_HOME) {
      return LOGIN_HOME;
    } else {
      return LOGIN;
    }
  }

  handleMore() {
    this.getTopics(this.state.page);
  }

  handleClosePopupAlertDialog(e) {
    e.preventDefault();

    this.setState(
      {
        showPopup: false
      },
      () => {
        popupStorage.setHidePopup(this.props.projectId);
      }
    );
  }

  handleOpenShareGameDialog(event) {
    event.preventDefault();

    this.setState({
      showShareGameDialog: true
    });
  }

  handleCloseShareGameDialog() {
    this.setState({
      showShareGameDialog: false
    });
  }

  handleOpenTopicsListDialog(event) {
    event.preventDefault();

    this.setState({
      showTopicsListDialog: true
    });
  }

  handleCloseTopicsListDialog() {
    this.setState({
      showTopicsListDialog: false
    });
  }

  render() {
    const UNAVAILABLE_GAME_ERROR_LIST = [
      localize("unavailable_game_private", this.props.language),
      localize("unavailable_game_unpublished", this.props.language),
      localize("unavailable_game_deleted", this.props.language),
      localize("unavailable_game_no_topics", this.props.language),
      localize("unavailable_game_invalid", this.props.language)
    ];
    const UNAVAILABLE_GAME_ERROR_LIST_LOGGEDIN = [
      localize("unavailable_game_private_loggedin", this.props.language),
      localize("unavailable_game_unpublished", this.props.language),
      localize("unavailable_game_deleted", this.props.language),
      localize("unavailable_game_no_topics", this.props.language),
      localize("unavailable_game_invalid", this.props.language)
    ];
    const IS_EMBEDDED_PROJECT =
      sessionStorageService.getItem("embedded_project") === "true"
        ? true
        : false;

    if (
      this.state.topics &&
      (this.state.topics.length !== 0 || this.state.categories)
    ) {
      /*
        Setting a key prop for ProjectPage will allow the interface to be reset.
        This is evident in mobile Project view, where you will be directed back
        to the first slide. States are reset in componentDidUpdate().
      */
      return (
        <ProjectPage
          sessionKey={this.props.sessionKey}
          ref={projectPage => (this.projectPage = projectPage)}
          key={this.props.projectId}
          projectId={this.props.projectId}
          id={this.props.id}
          project={this.state.project}
          projectImage={this.state.project.bannerImage}
          buttons={this.props.buttons}
          categories={this.state.categories}
          topics={this.state.topics}
          more={this.state.more}
          showcaseProject={this.state.showcaseProject}
          popup={this.state.popup}
          showPopup={this.state.showPopup}
          handleClosePopupAlertDialog={this.handleClosePopupAlertDialog}
          showShareGameDialog={this.state.showShareGameDialog}
          handleOpenShareGameDialog={this.handleOpenShareGameDialog}
          handleCloseShareGameDialog={this.handleCloseShareGameDialog}
          showTopicsListDialog={this.state.showTopicsListDialog}
          handleOpenTopicsListDialog={this.handleOpenTopicsListDialog}
          handleCloseTopicsListDialog={this.handleCloseTopicsListDialog}
          handleMore={() => this.handleMore()}
          user={this.props.user}
          team={this.props.team}
          notifications={this.props.notifications || 0}
          inboxUnread={this.props.inboxUnread || 0}
          language={this.props.language}
        />
      );
    } else if (this.state.topics && !this.props.sessionKey) {
      /* No information is returned, but not logged in */
      return (
        <GenericErrorPage
          routeUrl={this.getLoginRoute()}
          routeName={localize("button_login", this.props.language)}
          message={localize("unavailable_game_long", this.props.language)}
          messageList={UNAVAILABLE_GAME_ERROR_LIST}
          endMessage={localize(
            "unavailable_game_login_prompt",
            this.props.language
          )}
          isBackRoute={false}
          language={this.props.language}
        />
      );
    } else if (this.state.topics) {
      /* No information is returned, but logged in */
      return (
        <GenericErrorPage
          routeUrl={SINGLE_PROJECT_APP || IS_EMBEDDED_PROJECT ? null : HOME}
          routeName={localize("icon_home", this.props.language)}
          message={localize("unavailable_game_long", this.props.language)}
          messageList={UNAVAILABLE_GAME_ERROR_LIST_LOGGEDIN}
          language={this.props.language}
        />
      );
    } else {
      return <Loading />;
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectContainer);
